import { useInfiniteQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";
import type { ChatThreadClient } from "../../types/chat";

export const useInfiniteMessages = (chatThreadClient: ChatThreadClient | null, threadId?: string) => {
  return useInfiniteQuery({
    queryKey: ["infinite-messages", threadId],
    queryFn: async ({ pageParam }) => {
      const result = await chatApi.getMessages(chatThreadClient, pageParam, 200);
      return result;
    },
    getNextPageParam: (lastPage) => lastPage.iterator,
    enabled: !!chatThreadClient && !!threadId,
    refetchOnMount: true,
    staleTime: 0,
  });
};
